import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const InstacartLogo = ({
  width = '50',
  height = '50'
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <IconSvg
      style={{
        width: width,
        height: height
      }}
      viewBox="0 0 700 700"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M349.98 429.5C452.042 429.5 535.713 505.677 535.48 615H164.501C164.294 505.73 247.933 429.5 349.98 429.5Z"
        fill="#FF7009"
      />
      <path
        d="M502.98 170.955C479.543 170.955 462.843 181.168 447.42 203.333L403.001 267.15V85H297.001V267.15L252.581 203.333C237.158 181.168 220.458 170.955 197.021 170.955C161.66 170.955 138.117 197.063 138.001 229.229C137.9 256.789 150.901 274.735 178.281 292.362L350.001 403L521.721 292.362C549.085 274.735 562.085 256.778 562.001 229.229C561.884 197.063 538.341 170.955 502.98 170.955Z"
        fill="#0AAD0A"
      />
    </IconSvg>
  )
}

export default InstacartLogo
